/** @format */

import { Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import { productAvailableListColumns } from "../../../../constants/tables/productAvailableListColumns";
import { TWarehouse } from "../../../../redux-modules/declarations/maps/warehouses";
import { useDebounce } from "../../../../redux-modules/hooks/useDebounce";
import { AddProductAvailableDrawer } from "../../../layout/SideDialogs/AddProductAvailable";
import { UIButton } from "../../../ui/Button";
import { UISearch } from "../../../ui/SearchInput";
import { UITable } from "../../../ui/Table";

/** @format */
interface Props {
  available_products: unknown[];
  warehouseInfo: TWarehouse;
  updateData: () => void;
}
export const WarehouseAvailableTab = ({
  available_products,
  warehouseInfo,
  updateData,
}: Props): JSX.Element => {
  const [showingAddModal, setShowingAddModal] = useState(false);
  const [searchingVal, setSearchingVal] = useState("");
  const [filteredTable, setFilteredTable] = useState<unknown[]>();

  const handleSearch = (value: string, list: unknown[] | false = false): void => {
    const filterTable = list
      ? list.filter(o =>
          // @ts-ignore
          Object.keys(o).some(k => String(o[k]).toLowerCase().includes(value.toLowerCase())),
        )
      : available_products.filter(o =>
          // @ts-ignore
          Object.keys(o).some(k => String(o[k]).toLowerCase().includes(value.toLowerCase())),
        );
    setFilteredTable(filterTable);
  };

  const openModal = (): void => setShowingAddModal(true);
  const closeModal = (): void => setShowingAddModal(false);

  let parolaCercata = useDebounce(searchingVal, 500);
  useEffect(() => {
    handleSearch(searchingVal);
  }, [parolaCercata]);

  return (
    <>
      <AddProductAvailableDrawer
        visible={showingAddModal}
        warehouse_id={warehouseInfo.id}
        onClose={closeModal}
        updateData={updateData}
      />
      <Row
        justify="space-between"
        align="middle"
        gutter={[16, 16]}
        style={{ marginBottom: "10px" }}
      >
        <Col>
          <UISearch
            placeholder={"Cerca disponibilità"}
            //onSearch={(e): void => handleSearch(e)}
            //allowClear
            onChange={(e): void => setSearchingVal(e.target.value)}
          />
        </Col>
        <Col>
          <UIButton type="primary" onClick={openModal}>
            + Aggiungi disponibilità
          </UIButton>
        </Col>
      </Row>
      <UITable
        size="middle"
        data-cy="product-available-list-table"
        columns={productAvailableListColumns}
        dataSource={filteredTable || available_products}
      />
    </>
  );
};
